import { Button, Caption, pxToRem, useStyles } from '@archipro-design/aria';
import * as S from './HelpGuideStepTwo.style';
import { TagLine } from '@archipro-design/icons';
import { ThumbUpLine } from '@archipro-design/icons';

interface HelpGuideStepTwoProps {
    onClose?: () => void;
}

const HelpGuideStepTwo = (props: HelpGuideStepTwoProps) => {
    const { onClose } = props;
    const { css } = useStyles();
    return (
        <div className={css(S.HelpGuideStepTwo)}>
            <Caption className={css(S.Title)}>
                <TagLine
                    color={'#313131'}
                    styles={{
                        width: pxToRem(14),
                        height: pxToRem(14),
                        marginRight: pxToRem(8),
                    }}
                />
                Review & Approve Tags
                <span className={css(S.Step)}>2/2</span>
            </Caption>
            {/* TODO: Add back once we have the move tag feature */}
            {/* <div className={css(S.Description)}>
                Check the tag is on the correct product, move to a better
                position if needed.
            </div> */}
            <div className={css(S.Description)}>
                Finally, approve the tag using the thumbs up icon{' '}
                <ThumbUpLine />
            </div>
            <div className={css(S.Button)}>
                <Button
                    color="white"
                    size={14}
                    variant="outlined"
                    onClick={onClose}
                >
                    Close
                </Button>
            </div>
        </div>
    );
};

export default HelpGuideStepTwo;
